import { TaxUpdatePage } from '@/features/tax/pages/TaxUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/tax/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["tax.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: TaxUpdatePage,
})
